// Cuándo corresponde ofrecer la encuesta de feedback en la home —
// ADR-2026-09-21-la-encuesta-vuelve-a-la-home-con-piso-de-uso.
//
// La encuesta (`CuestionarioModal`, +10 imágenes de premio) era uno de los tres
// carteles sueltos de la cuenta paga y salió del recorrido cuando los otros dos se
// unificaron en la tarjeta de configuración
// (ADR-2026-08-27-tarjeta-configuracion-cuenta-paga): no es configuración de la cuenta
// y competía por la misma atención que los dos pasos que sí lo son. El modal quedó en
// el repo sin ningún llamador.
//
// Vuelve, y ARRIBA de la tarjeta de configuración, pero con un piso de uso que el
// cartel viejo no tenía. El piso es lo que responde la objeción de aquel ADR: quien
// generó 30 imágenes no es alguien peleando con la configuración de su cuenta, es
// alguien que ya trabaja con Atlas — y es justo a ese al que le sirve preguntarle.
//
// El cartel viejo pedía en cambio DOS SEMANAS de antigüedad, y eso ya se había
// eliminado por partir la secuencia de quien recién se suscribía (ADR-889). El piso de
// uso mide lo que la antigüedad quería medir —¿esta persona conoce el producto?— sin
// castigar a la que arrancó rápido.

/**
 * Cuántas creaciones hay que tener para que la encuesta aparezca.
 *
 * Cuenta **todas** las filas de `imagenes_generadas` de la empresa: los videos también
 * (viven en la misma tabla y son una generación igual) y las borradas también (una
 * creación borrada igual se generó y se cobró — el piso mide cuánto usó la app, no
 * cuánto conserva).
 */
export const MINIMO_GENERADAS_PARA_ENCUESTA = 30;

/**
 * ¿Le toca ver el cartel de la encuesta?
 *
 * `generadas` en `null` significa que el conteo no se pudo hacer, y ahí NO se muestra:
 * un cartel que aparece porque una consulta falló prometería un premio sin saber si
 * corresponde, y como no se puede descartar el usuario se lo tendría que bancar hasta
 * responder.
 */
export function correspondeEncuesta({
  esPago,
  respondido,
  generadas,
}: {
  esPago: boolean;
  /** `company_profiles.cuestionario_respondido`. */
  respondido: boolean;
  /** Filas de `imagenes_generadas` de la empresa, o `null` si el conteo falló. */
  generadas: number | null;
}): boolean {
  if (!esPago || respondido) return false;
  if (generadas === null) return false;
  return generadas >= MINIMO_GENERADAS_PARA_ENCUESTA;
}
